import { Outlet } from 'react-router-dom';

export default function Parties() {
  return <Outlet />;
}
